import styled from 'styled-components';

const P = styled.p`
  font-size: 0.86em;
  font-family: inherit;
`;

export default P;



// WEBPACK FOOTER //
// ./app/components/P/index.js